/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { getCachedUserToken } from '../../../utilities/caching';
import { gotoUrlEnvironment } from '../../../utilities/helpers';
import { ACCOUNT_REGIONS } from '../../../utilities/constants';
import { walletCurrenciesTypes } from '../constants';
import { useLedgerFilteredWallets } from '../../../utilities/sharedHooks/ledgerWallets';
import { WALLETS_ALL } from '../queries';
import {
  TOPUP_ACCOUNTS_QUERY_PARAM,
  TOPUP_DEEPLINK_QUERY_PARAMS,
  TOPUP_DEEPLINK_SESSION_KEYS,
  TOPUP_SELECT_CURRENCY,
} from './constants';

const TopupDeeplink = () => {
  const location = useLocation();
  const history = useHistory();

  const { data: allWallets } = useLedgerFilteredWallets(WALLETS_ALL);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const currency = searchParams.get(TOPUP_DEEPLINK_QUERY_PARAMS.CURRENCY);
    const appId = searchParams.get(TOPUP_DEEPLINK_QUERY_PARAMS.APP_ID);
    const pathname = location.pathname.replace(/\/+$/, '');

    const isRowApp = appId === process.env.REACT_APP_ROW_APP_NAME;
    const isUsApp = appId === process.env.REACT_APP_US_APP_NAME;
    const isValidAppId = isRowApp || isUsApp;
    const isOnRowHost = window.location.hostname === process.env.REACT_APP_FE_BASE_HOSTNAME;
    const isOnUsHost = window.location.hostname === process.env.REACT_APP_US_FE_BASE_HOSTNAME;

    const topupUrl = (walletType, value) =>
      `/dashboard/accounts/${walletType}?${TOPUP_ACCOUNTS_QUERY_PARAM}=${value}`;

    // client always enters through the ROW base URL; hop to the US app unless
    // we're already on the app that matches the given app_id.
    if (isValidAppId && !(isRowApp && isOnRowHost) && !isOnUsHost) {
      gotoUrlEnvironment(ACCOUNT_REGIONS.US, `${pathname.slice(1)}${location.search}`);
      return;
    }

    // Remembered before the wallets are read: an expired token makes that
    // request answer 401, which resets the session and hard-redirects to
    // /timeout, so this is the only chance to record where to come back to.
    sessionStorage.setItem(TOPUP_DEEPLINK_SESSION_KEYS.RETURN_URL, `${pathname}${location.search}`);

    const token = getCachedUserToken();
    if (!token) {
      history.push('/onboarding/login');
      return;
    }

    if (!currency) {
      sessionStorage.removeItem(TOPUP_DEEPLINK_SESSION_KEYS.RETURN_URL);
      history.push(topupUrl(walletCurrenciesTypes.CRYPTO, TOPUP_SELECT_CURRENCY));
      return;
    }

    if (!allWallets) return;

    const matchedWallet = allWallets.find(
      (wallet) => wallet.coin?.toUpperCase() === currency.toUpperCase()
    );
    const isFiatWallet =
      matchedWallet && matchedWallet.wallet_type?.toLowerCase() === walletCurrenciesTypes.FIAT;

    sessionStorage.removeItem(TOPUP_DEEPLINK_SESSION_KEYS.RETURN_URL);
    history.push(
      topupUrl(
        isFiatWallet ? walletCurrenciesTypes.FIAT : walletCurrenciesTypes.CRYPTO,
        encodeURIComponent(currency)
      )
    );
  }, [allWallets]);

  return null;
};

export default TopupDeeplink;
